<template>
    <section class="not-found">
        <div class="not-found-500">500</div>
        <div class="not-found-title">{{_T('Server error')}}</div>
        <a class="not-found-link" href="/">{{_T('Go to home page')}}</a>
    </section>
</template>
<script>
    import * as utils from "@/utils/main_utils";
import { mapGetters } from 'vuex';
    export default {
        beforeMount()
        {
            document.title = '500 Error'
            utils.process_warning("Error 500 happened")
        },
        computed:{
            ...mapGetters(['_T'])
        }
    };
</script>
<style lang="scss" scoped>

</style>
